import { useState } from 'react';

var useControl = function useControl() {
  var _a = useState(false),
    visible = _a[0],
    setVisible = _a[1];
  var onOpen = function onOpen() {
    setVisible(true);
  };
  var onClose = function onClose() {
    setVisible(false);
  };
  return {
    visible: visible,
    onOpen: onOpen,
    onClose: onClose
  };
};

export { useControl as default };
